export enum ValidatorTypes {
  required = 'required',
  email = 'email',
  phone = 'phone',
  minLength = 'minLength'
}
